import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Disclaimer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center text-gray-600 hover:text-gray-900 mb-8 transition-colors"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          {t('common.back', '返回')}
        </button>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            {t('disclaimer.title')}
          </h1>

          <div className="prose max-w-none">
            <p className="text-gray-600 mb-6">
              {t('disclaimer.lastUpdated')}: 2024-12-29
            </p>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                {t('disclaimer.sections.general.title')}
              </h2>
              <p className="text-gray-600 mb-4">
                {t('disclaimer.sections.general.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                {t('disclaimer.sections.noWarranties.title')}
              </h2>
              <p className="text-gray-600 mb-4">
                {t('disclaimer.sections.noWarranties.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                {t('disclaimer.sections.limitationOfLiability.title')}
              </h2>
              <p className="text-gray-600 mb-4">
                {t('disclaimer.sections.limitationOfLiability.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                {t('disclaimer.sections.externalLinks.title')}
              </h2>
              <p className="text-gray-600 mb-4">
                {t('disclaimer.sections.externalLinks.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                {t('disclaimer.sections.professionalAdvice.title')}
              </h2>
              <p className="text-gray-600 mb-4">
                {t('disclaimer.sections.professionalAdvice.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                {t('disclaimer.sections.fairUse.title')}
              </h2>
              <p className="text-gray-600 mb-4">
                {t('disclaimer.sections.fairUse.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                {t('disclaimer.sections.contactUs.title')}
              </h2>
              <p className="text-gray-600 mb-4">
                {t('disclaimer.sections.contactUs.content')}
              </p>
              <p className="text-gray-600">
                {t('disclaimer.sections.contactUs.email')}: support@ai2you.org
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}